import React from 'react';
import {useWindowDimensions, View} from 'react-native';

import Icon from '/component/base/Icon/Icon';
import Text from '/component/base/Text';
import {IncentiveTrip} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './FullyQualifiedBanner.style';
import {FullyQualifiedBannerProps} from './FullyQualifiedBanner.types';

export const FullyQualifiedBanner = ({
  totalCards = 0,
  cardNumber = 0,
  path = 0,
  onLearnMoreClick = () => {},
  style = {},
  bannerHeight = 0,
  handleBannerHeight,
}: FullyQualifiedBannerProps) => {
  const {fontScale} = useWindowDimensions();
  const isLargeFont = fontScale > 1.15;
  const {tt, ts} = useTranslation('incentiveTripBanner');

  return (
    <>
      <View
        style={{
          ...style?.banner,
          ...styles.bannerHeight,
          ...(bannerHeight ? {minHeight: bannerHeight} : {}),
        }}
        onLayout={handleBannerHeight}
        {...testProperties(IncentiveTrip.itBanner)}>
        <View
          style={[
            styles.headerContainer,
            isLargeFont && styles.headerContainerLargeFont,
          ]}
          {...testProperties(IncentiveTrip.itHeaderContainer)}>
          <Icon
            name={'circle-checkmark-filled'}
            style={styles.icon}
            {...testProperties(
              IncentiveTrip.itQualifiedForIncentiveTripCheckbox,
            )}
          />
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.headerText}
            {...testProperties(IncentiveTrip.itTitle)}>
            {ts(
              'title',
              'Congratulations! You have qualified for the OPTAVIA Incentive Trip 2024.',
            )}
          </Text>
          {totalCards &&
            cardNumber &&
            tt('sideTitle', () => (
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                variant="button"
                style={isLargeFont ? styles.sideTextLargeFont : undefined}
                {...testProperties(IncentiveTrip.itSideTitle)}>
                {cardNumber} of {totalCards}
              </Text>
            ))}
        </View>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.content}
          {...testProperties(IncentiveTrip.itDescription)}>
          You have completed all of the requirements for Path {path}.{' '}
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            onPress={onLearnMoreClick()}
            style={styles.link}
            {...testProperties(IncentiveTrip.itLearnMore)}>
            {ts('learnMore', 'Learn more')}
          </Text>
        </Text>
      </View>
    </>
  );
};
